module.exports = {
  onboardingPhone: require('./onboarding-phone-2.png'),
  onboardingPen: require('./onboarding-pen.png'),
  onboardingShop: require('./onboarding-shop.png'),
  fbLogo: require('./fb-logo.png'),
  fbLogoText: require('./fb-logo-text.png')
}
